import { useMemo } from "react"

const useTransferItems = ({
  table,
  targetProjectId,
  targetInvestments,
  sourceProjectId,
  sourceFiles,
  sourceInvestments,
  sourceTransactions,
  customTargets,
}) => {
  const investmentsToMove = useMemo(() =>
    table.current.getDataSource()
      .filter(({ isIncluded }) => isIncluded)
      .filter(({ sourceInvestmentId }) => !sourceInvestmentId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [ table, sourceInvestments, targetInvestments, targetProjectId, sourceProjectId, customTargets ])

  const investmentsToOverride = useMemo(() =>
    table.current.getDataSource()
      .filter(({ isIncluded }) => isIncluded)
      .filter(({ sourceInvestmentId }) => !!sourceInvestmentId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [ table, sourceInvestments, targetInvestments, targetProjectId, sourceProjectId, customTargets ])

  const filesToMove = useMemo(() =>
    investmentsToMove
      .map(({ id }) =>
        sourceFiles
          .filter(file => file.investmentId === id)
      )
      .reduce((cur, acc) => [ ...acc, ...cur ], [])
  , [ investmentsToMove, sourceFiles ])

  const filesToOverride = useMemo(() =>
    investmentsToOverride
      .map(({ sourceInvestmentId, id: targetInvestmentId }) =>
        sourceFiles
          .filter(file => file.investmentId === sourceInvestmentId)
          .map(file => ({ ...file, targetInvestmentId }))
      )
      .reduce((cur, acc) => [ ...acc, ...cur ], [])
  , [ investmentsToOverride, sourceFiles ])

  const transactionsToMove = useMemo(() =>
    investmentsToMove
      .map(({ id }) =>
        sourceTransactions.filter(transaction => transaction.investmentId === id)
      )
      .reduce((cur, acc) => [ ...acc, ...cur ], [])
  , [ investmentsToMove, sourceTransactions ])

  const transactionsToOverride = useMemo(() =>
    investmentsToOverride
      .map(({ sourceInvestmentId, id: targetInvestmentId }) =>
        sourceTransactions
          .filter(transaction => transaction.investmentId === sourceInvestmentId)
          .map(transaction => ({ ...transaction, targetInvestmentId }))
      )
      .reduce((cur, acc) => [ ...acc, ...cur ], [])
  , [ investmentsToOverride, sourceTransactions ])

  return {
    investmentsToMove,
    investmentsToOverride,
    filesToMove,
    filesToOverride,
    transactionsToMove,
    transactionsToOverride,
  }
}

export default useTransferItems;
